export const addproduct = (billNo, viewmodel, params, beforeAct, afterAct) => {
  let postData = {
    billNum: billNo,
    billId: viewmodel.get('id'),
    billCode: viewmodel.get('code')
  }
  let beforeActData = {
    params: params,
    data: postData
  }
  beforeAct(beforeActData, function () {
    let childrenField = null, referField = null;
    if (params.params) childrenField = params.params.childrenField;
    let gridModel = viewmodel.get(childrenField);
    let vmParams = viewmodel.getParams();
    const cancelCallBack = () => {
      let len = gridModel.getRows().length;
      gridModel.deleteRows([len - 1]);
      //设置状态栏字体白色
      cb.utils.setStatusBarStyle("light");
      cb.route.goBack();
    }
    vmParams.cancelCallBack = cancelCallBack;
    let cParameter = params.cParameter;
    try {
      cParameter = JSON.parse(cParameter);
      referField = cParameter.referField;
    } catch (e) {
      cb.utils.alert('cParameter解析失败~', 'error');
    }
    let pathList = cb.rest.history.location.pathname.split('/');
    let pathname = pathList[pathList.length - 1];
    cb.route.pushPage(`/voucherRefer/${pathname}/${referField}/${childrenField}`)
    cb.rest.bAddProduct = true;
    if (gridModel) gridModel.appendRow({});
    afterAct()
  })
}

export const scan = (billNo, viewmodel, params, beforeAct, afterAct) => {
  let postData = {
    billNum: billNo,
    billId: viewmodel.get('id'),
    billCode: viewmodel.get('code')
  }
  let beforeActData = {
    params: params,
    data: postData
  }
  beforeAct(beforeActData, function () {
    var onScan = null;
    if (params.params) onScan = params.params.onScan
    var isImScanBar = cb.utils.IsIMScanBar();
    if (isImScanBar) {
      cb.utils.alert('此设备可以直接用扫码枪！', 'info');
      return;
    } else if (cb.rest.isWeChat) {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          let model = viewmodel.get('barcode');
          let resultStr = res.resultStr.split(',');
          if(resultStr.length > 1)
            resultStr = resultStr[1]
          else
            resultStr = resultStr[0];
          if (model) {
            model.setValue(resultStr, true);
            model.fireEvent('enter', resultStr);
          }
        }
      });
    } else {
      if (onScan) onScan();
    }
    afterAct()
  })
}



// WEBPACK FOOTER //
// ./src/yxyweb/client/common/voucher_M.js